(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    const switchers = document.querySelectorAll('.lang-switcher');

  switchers.forEach((switcher) => {
    const trigger = switcher.querySelector('.lang-trigger');
    const dropdown = switcher.querySelector('.lang-dropdown');
    const chevron = switcher.querySelector('.lang-chevron');
    if (!trigger || !dropdown) return;

    trigger.addEventListener('click', () => {
      const isOpen = dropdown.classList.contains('is-open');
      dropdown.classList.toggle('is-open', !isOpen);
      chevron?.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  document.addEventListener('click', (e) => {
    switchers.forEach((switcher) => {
      if (switcher.contains(e.target)) return;
      switcher.querySelector('.lang-dropdown')?.classList.remove('is-open');
      switcher.querySelector('.lang-chevron')?.classList.remove('is-open');
      switcher.querySelector('.lang-trigger')?.setAttribute('aria-expanded', 'false');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    const trigger = document.getElementById('mobile-menu-trigger');
  const menu = document.getElementById('mobile-menu');

  function closeMenu() {
    menu.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.inert = true;
    document.body.style.overflow = '';
    if (window.__lenis) window.__lenis.start();
  }

  trigger?.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(isOpen));
    menu.setAttribute('aria-hidden', String(!isOpen));
    menu.inert = !isOpen;
    document.body.style.overflow = isOpen ? 'hidden' : '';
    if (window.__lenis) window.__lenis[isOpen ? 'stop' : 'start']();
  });

  /* Menu link clicks: always close menu first, then navigate or scroll */
  menu?.addEventListener('click', (e) => {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;

    let parsed;
    try { parsed = new URL(href, location.href); } catch (_) { return; }

    const samePage = parsed.pathname === location.pathname;
    const hash = parsed.hash;

    if (samePage && hash) {
      /* Same-page anchor: close menu, then smooth-scroll */
      const target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      closeMenu();
      setTimeout(() => {
        if (window.__lenis) {
          window.__lenis.scrollTo(target, { offset: -80, duration: 1 });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 420);
    } else if (!samePage && hash) {
      /* Cross-page anchor: close menu, navigate after short delay so menu starts closing */
      e.preventDefault();
      closeMenu();
      setTimeout(() => { location.href = parsed.href; }, 200);
    }
    /* Plain cross-page links: let browser handle normally (menu closes on navigation) */
  });

  if (trigger) {
    let lastY = window.scrollY;
    let ticking = false;

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const currentY = window.scrollY;
          const isOpen = menu?.classList.contains('is-open');
          const hide = !isOpen && currentY > lastY && currentY > 80;
          trigger.classList.toggle('is-hidden', hide);
          lastY = currentY;
          ticking = false;
        });
      },
      { passive: true }
    );
  }

  document.querySelectorAll('.mobile-assortiment, .mobile-submenu').forEach((details) => {
    const content = details.querySelector('.mobile-assortiment-content, .mobile-submenu-content');
    const summary = details.querySelector('summary');
    if (!content || !summary) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      if (details.hasAttribute('open')) {
        content.style.maxHeight = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });
        content.addEventListener('transitionend', function handler() {
          details.removeAttribute('open');
          content.removeEventListener('transitionend', handler);
        });
      } else {
        details.setAttribute('open', '');
        content.style.maxHeight = '0px';
        requestAnimationFrame(() => {
          content.style.maxHeight = content.scrollHeight + 'px';
        });
        content.addEventListener('transitionend', function handler() {
          content.style.maxHeight = 'none';
          content.removeEventListener('transitionend', handler);
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
